import React from "react";

interface ConfiguratorTitleProps {
  title: string;
}

const ConfiguratorTitle: React.FC<ConfiguratorTitleProps> = ({ title }) => {
  return (
    <h1 className="text-left text-lg sm:text-lg md:text-3xl font-bold mt-2 mb-4 md:mb-2 pb-2 md:pb-2">
      {title}
    </h1>
  );
};

export default ConfiguratorTitle;
